// @flow
import React from 'react'

import styles from './play.module.scss'

interface Props {
  className?: string
  onClick?: () => void
  disabled?: boolean
}

const ButtonPlay = ({ className, onClick, disabled }: Props) => (
  <button
    type="button"
    aria-label="Play"
    className={`btn-chromeless circle ${className} ${styles.btn}`}
    onClick={onClick}
    disabled={disabled}
  >
    <svg width="100%" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
      <circle className={styles.circle} cx="20" cy="20" r="20" />
      <path className={styles.play} d="M16 27V14l13 6.5z" />
    </svg>
  </button>
)

ButtonPlay.defaultProps = {
  className: '',
  onClick: null,
  disabled: false,
}

export default ButtonPlay
